"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var initStoredValuesFromControls = function initStoredValuesFromControls(controls) {
  var storedValues = {};

  for (var i = 0; i < controls.length; i += 1) {
    var _controls$i = controls[i],
        fieldId = _controls$i.fieldId,
        fieldData = _controls$i.fieldData;
    storedValues[fieldId] = {
      fieldKey: fieldData.fieldKey,
      value: fieldData.value,
      isValid: false
    };
  }

  return storedValues;
};

var _default = initStoredValuesFromControls;
exports["default"] = _default;